import React, { Component } from "react";
import block from "bem-cn-lite";
import connect from "../store";
import { I18n } from "react-i18next";
import i18n from "../../i18n";

import TopMenu from "../../Components/TopMenu";

const b = block("Gantt_Header");

class GanttHeader extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(event) {
        event.stopPropagation();
        if (!this.props.tooltips.find(tooltip => tooltip.name === "trial")) {
            this.props.setGlobalState({
                tooltips: [
                    {
                        name: "trial",
                        text: i18n.t("global:freeTrialTooltip")
                    },
                    ...this.props.tooltips
                ]
            });
        }
    }

    render() {
        const { header } = this.props;

        return (
            <I18n>
                {(t) => (
                    <div
                        className={b()}
                        onMouseDown={e => {
                            e.stopPropagation();
                        }}
                        onClick={this.onClick}
                    >
                        <div className={b("top")}>
                            <div className={b("title")} dangerouslySetInnerHTML={ { __html: header } }></div>
                            <div className={b("menu")}>
                                <TopMenu
                                    items={[
                                        t("global:timeline"),
                                        t("global:stream"),
                                        t("global:more")
                                    ]}
                                    current={0}
                                />
                            </div>
                        </div>
                        <div className={b("bottom")}>
                            <div className={b("filters")}>
                                <span className={b("filter-icon")}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="11"
                                        height="12"
                                        viewBox="0 0 10 11"
                                    >
                                        <polygon
                                            fill="#CEDBE1"
                                            fillRule="evenodd"
                                            points="184 4 194 4 194 4 194 4 194 5.052 193.956 5.052 190.111 8.692 190.111 15 187.889 12.896 187.889 8.687 184.05 5.052 184 5.052"
                                            transform="translate(-184 -4)"
                                        />
                                    </svg>
                                </span>
                                <span className={b("filter")}>
                                    {t("gantt:filters.filters")}
                                </span>
                            </div>
                            <div className={b("switchers")}>
                                <span className={b("switcher")}>
                                    {t("gantt:filters.cascade")}
                                </span>
                                <span className={b("switcher")}>
                                    {t("gantt:expandAll")}
                                </span>
                                <span className={b("switcher")}>
                                    {t("gantt:collapseAll")}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </I18n>
        );
    }
}

// const GanttHeader = ({ header, setGlobalState, tooltips }) => <div className={b()} onClick={e => {
//         e.stopPropagation();
//         if(!tooltips.find(tooltip => tooltip.name === 'trial'))
//             setGlobalState({
//                 tooltips: [{
//                     name: 'trial',
//                     text: i18n.t('global:freeTrialTooltip')
//                 }, ...tooltips]
//             })
//     }}
//     onMouseDown={e => {
//         e.stopPropagation();
//     }}>

//     {header}
// </div>

export default connect(GanttHeader);
